import React, { useEffect, useRef } from 'react';
import './VideoEmbed.css';

/**
 * VideoEmbed component
 * 
 * Accepts a direct videoLink instead of a videoId.
 */
const VideoEmbed = ({ videoLink, title, onComplete }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin === 'https://innerloop.stream') {
        const data = event.data;
        if (data.event === 'videoComplete' && onComplete) {
          console.log('Video completed');
          onComplete();
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onComplete]);

  return (
    <div className="video-embed-container">
      <iframe
        ref={iframeRef}
        src={videoLink}
        title={title || 'Video Player'}
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      ></iframe>
    </div>
  );
};

export default VideoEmbed;